import Support from '../components/Support/Support';

const SupportPage = () => <Support />;

export default SupportPage;
